import { SelectOption } from "../../../../types/select";
import { isObject } from "../isObject";

export function isSelectOption(val: unknown): val is SelectOption {
  if (!isObject(val) || !("label" in val) || !("value" in val)) return false;
  return typeof val?.label === "string" || typeof val?.label === "number";
}
